import { Podcast } from '@/types/podcast'
import { ImageTransform } from '@/types/image'
import { Video } from '@/types/widget/video'

export interface NewEpisode {
  name: string
  podcast: Podcast | null
  podcast_id?: number | null
  code?: string
}

export interface DetailEpisode {
  podcast?: Podcast | null
  name?: string
  description?: string | null
  author?: string | null
  type?: string
  status?: boolean
  active?: boolean
  adult?: boolean
  square_image_id?: number | null
  social_image_id?: number | null
  format?: string
  season?: number | null
  number?: number | null
  active_from?: string
  podcast_id?: number
  audio?: string | null
  audio_id?: number | null
  id: number
  code?: string | null
  video?: Video | null
  video_id?: number | null
  squareImage?: ImageTransform | null
  socialImage?: ImageTransform | null
  transcribation?: Transcribation | null
}

export interface Episode {
  active_from: string | null
  code: string
  created_at: string
  duration?: null | number
  id: number
  image_id?: number | null
  podcast: Podcast
  status: boolean
  type: string
  active: boolean
  name: string
}

export interface Transcribation {
  id: number
  status?: TranscribationStatus
  text?: string
  is_published: boolean
  yandex_operation_id?: number | null
}

export enum TranscribationStatus {
  PENDING = 0,
  DONE = 1,
}
